<template>
  <header
    class="
      flex
      items-center
      justify-between
      px-6
      py-2
      bg-white
      border-b-4
    "
  >
    <div class="flex items-center">
      <button
        v-on:click="useSideBar"
        class="text-gray-500 focus:outline-none"
      >
        <svg
          class="w-6 h-6"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6H20M4 12H20M4 18H11"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </header>
</template>

<script setup lang="ts">
import {useStore} from "vuex";
const store = useStore()
const useSideBar = () => store.commit("sideBar/useSideBar")
</script>
